module.exports = __webpack_public_path__ + "static/media/classroom.7ad10d37.svg";